//考勤查询路由，外部地址

const annualRouter = [{
		path: "/extra/annual/absence/:type",
		name: "absence",
		component: () => import("@/views/annual/absence"),
		hidden: true,
		meta: {
			title: "缺勤类型"
		}
	},
	{
		path: "/extra/annual/shiftclock/:type",
		name: "shiftclock",
		component: () => import("@/views/annual/shiftclock"),
		hidden: true,
		meta: {
			title: "排班打卡"
		}
	},
	{
		path: "/extra/annual/person/:type",
		name: "person",
		component: () => import("@/views/annual/person"),
		hidden: true,
		meta: {
			title: "个人中心"
		}
	},
	{
		path: "/extra/annual/surplus/:type",
		name: "surplus",
		component: () => import("@/views/annual/surplus"),
		hidden: true,
		meta: {
			title: "假期定额"
		}
	},
	{
		path: "/extra/annual/workovertime/:type",
		name: "workovertime",
		component: () => import("@/views/annual/workovertime"),
		hidden: true,
		meta: {
			title: "加班情况"
		}
	}
];

export default annualRouter;